import { useEffect } from "react";

import { useSearchParams } from "next/navigation";

import { TClassName, usePixel } from "shared/utils/hooks/Pixel";
import { useAuthContext } from "shared/utils/hooks/useAuthContext";

import { captureException, captureMessage } from "@sentry/nextjs";

const useTrackViewContent = (groupData) => {
  const { setTrackViewContent } = usePixel();
  const { loggedUser } = useAuthContext();

  const params = useSearchParams();
  const group_slug = params.get("group_slug");
  const ref = params.get("ref");

  useEffect(() => {
    try {
      const payload = {
        productId: groupData?.id,
        productName: groupData?.title,
        className: "App\\Group" as TClassName,
        slug: group_slug as string,
        promoterLink: ref as string,
      };
      setTrackViewContent(payload, loggedUser);
    } catch (error) {
      console.log("Erro (ProductPresentationTemplate::useEffect): ", error);
      captureException(error);
      captureMessage("Erro (ProductPresentationTemplate::useEffect)");
    }
  }, [groupData?.id]);

  return {};
};

export default useTrackViewContent;
